/**
 * Register Pipedrive Integration
 * Registers the Pipedrive CRM integration with the integration registry
 */

import { integrationRegistry } from '../registry/IntegrationRegistry';
import { pipedriveIntegrationFactory } from './PipedriveIntegrationFactory';

/**
 * Register Pipedrive integration with the system
 */
export function registerPipedriveIntegration(): void {
  integrationRegistry.register(
    'crm:pipedrive',
    'Pipedrive CRM',
    'crm',
    'pipedrive',
    '1.0.0',
    pipedriveIntegrationFactory
  );

  console.log('Pipedrive CRM integration registered successfully');
}

/**
 * Unregister Pipedrive integration
 */
export function unregisterPipedriveIntegration(): void {
  integrationRegistry.unregister('crm:pipedrive');
  console.log('Pipedrive CRM integration unregistered');
}

// Auto-register when module is imported
registerPipedriveIntegration();